import React from "react"
import "./CourseDetails.css"
import "./general.css"
//import { online } from "../../dummydata"
//import { FaEdgeLegacy } from "react-icons/fa";

const MobileApp = () => {
  return (
    <>
   <div className="section home wf-section mobile-ap">
    <div className="flex-container flex-on-tablet w-container">
      <div className="text-content light narrow">
       <h1 className="first-title white">Mobile App Development</h1>
     </div>

     <div className=" non-hide">
      <div className="container" id="request">
        

        </div>
      </div>
    </div>
  </div>
   


<div className="page-wrap">
  <div className="section wf-section">
    <div className="course-columns">
      <div className="sticky-column">
        <div className="nav-holder"><a href="#introduction" className="course-nav-button w-inline-block t-content">
          <div>Introduction</div>
          </a><a href="#program" className="course-nav-button w-inline-block t-content">
          <div>Program Summary</div>
          </a><a href="#career" className="course-nav-button w-inline-block t-content">
          <div>Career Opportunities</div>
          </a><a href="#requirements" className="course-nav-button w-inline-block t-content">
          <div>Course Content</div>
          </a><a href="#course_content" className="course-nav-button w-inline-block t-content">
          <div>Requirements</div>
         
          </a></div>
        <a href="/apply-mobile-app" className="button full-width top-padding w-button c-buuton">APPLY NOW</a>
      </div>
      

      <div className="course-content">
        <div id="introduction" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Program Highlights</h2>
            <ul>
                 <li><span class="semi-bold offset-padding">Course Curriculum :</span> <span class="bold">Certificate Program</span></li>

                <li><span className="semi-bold offset-padding">Duration :</span><span className="bold"> 1 year</span></li>
                <li><span className="semi-bold offset-padding">Format :</span><span className="bold"> (Online/ In- person) </span></li>
                <li><span className="semi-bold offset-padding">Center :</span> <span className="bold"> Tema Mataheko</span> </li>
            </ul>
          </div>
        </div>
        <div id="introduction" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Introduction</h2>
			<p className="paragraph-2">
            A mobile app development course using React Native provides you with the skills and knowledge necessary to build cross-platform mobile applications for iOS and Android using the React Native framework.
            </p>
			<p className="paragraph-2">The course will start with an introduction to React Native, explaining its purpose and advantages in mobile app development. You'll learn about the basic concepts, architecture, and how React Native differs from other frameworks.</p>
			<p className="paragraph-2">
            JavaScript and React Fundamentals: Since React Native is built on top of React, the course will cover the fundamental concepts of JavaScript and React. You'll learn about components, state management, props, JSX syntax, and other essential concepts required for building React Native apps.
            </p>
	
            
			</div>
        </div>
      
        <div id="program" className="group">
          <div className="text-content centered">
            <h2 className="second-title">Program Summary</h2>
            <p className="paragraph">
				<ul>
					<li className="">Introduction to React Native and Front-End Development</li>
					<li className="">Exploring different navigation types (stack, tab, drawer)</li>
					<li className="">Fetching and displaying data from an API</li>
					<li className="">Back-End Development with Express and MongoDB</li>
					<li className="">Advanced React Concept</li>
					<li className="">User authentication and authorization using JSON Web Tokens (JWT)</li>
					<li className="">Full-Stack Development and Project Implementation</li>
				</ul>
			</p>
			<p>If you are new to IT and wish to create Mobile Applications for businesses or brands, this is the course for you.</p>
          </div>
        </div>
        
        <div id="career" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Career Opportunities</h2>
            <p className="paragraph">
			<ul>
                <li>Mobile App Developer</li>
				<li>Front-End Developer</li>
				<li>Full-Stack Developer</li>
				<li>Mobile App Consultant</li>
				<li>React Native Trainer or Instructor</li>
				<li>Open-Source Contributor</li>
				<li>Back-End Developer</li>
				
			</ul>
            </p>
           
          </div>
        </div>
        <div id="course_content" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Course Content</h2>
            <p className="paragraph">
            <div className="container inner_content_block2" id="inner_content_block2">

				<div className="row margin-bottom30 ">
					<div className="col-md-6 ">
						<ul>
						<li>Introduction to Mobile App Development and React Native</li>
						<li>Setting up the development environment (Node.js, npm, React Native CLI)</li>
						<li>Working with styles and layout in React Native</li>
						<li>Building a simple user interface with multiple components</li>
						<li>Working with data in React Native using Axios for HTTP requests</li>
						<li>Fetching and displaying data from an API</li>
						<li>Introduction to asynchronous programming (Promises, async/await)</li>
						<li>Introduction to back-end development and RESTful APIs</li>
						</ul>
					</div>
					<div className="col-md-6">
						<ul>
							<li>Setting up an Express.js server</li>
							<li>Handling HTTP requests (GET, POST, PUT, DELETE)</li>
							<li>Data modeling with MongoDB and Mongoose</li>
							<li>Performing CRUD operations with MongoDB</li>
							<li>Implementing data validation and error handling</li>
							<li>User authentication and authorization using JSON Web Tokens (JWT)</li>
							<li>Advanced topics in back-end development</li>
							<li>Real-time communication with WebSockets using Socket.IO</li>
						</ul>
					</div>
				</div>
				
				
			</div>
			</p>
          </div>
        </div>
		
        <div id="requirements" className="group ">
          <div className="text-content centered">
            <h2 className="second-title">Eligibility Requirements</h2>
			<ul>
				<li>Minimum of Basic Education Certificate</li>
			</ul>
           
        </div>
        <div id="admissions" className="group ">
          
          <a href="/apply-data-analytics" className="button full-width top-padding w-button c-buuton">APPLY NOW</a></div>
        </div>
      </div>
    </div>
  </div>
</div>

            
    </>
  )
}

export default MobileApp;
